import { render, staticRenderFns } from "./IpoResultAccounts.vue?vue&type=template&id=d42c7658"
import script from "./IpoResultAccounts.vue?vue&type=script&lang=js"
export * from "./IpoResultAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports